import PropTypes from 'prop-types';
import Slides from 'components/Slides';
import { getCMSDocumentSrc } from 'utils/getCMSDocumentSrc';

/**
 * Onboarding (Slides) — UX pensada para mobile/WebView.
 * En desktop sigue funcionando pero se centra con max-width acotado
 * para evitar que ocupe pantallas enormes.
 */
const OnboardingBlock = ({ value, blockProps = {} }) => (
  <section className='cms-block cms-block--onboarding w-full min-w-0'>
    <div className='w-full min-w-0 md:max-w-2xl lg:max-w-2xl mx-auto'>
      <Slides
        slides={(value?.slides || []).map((slide) => ({
          id: slide.id,
          ...slide.value,
          image: slide?.value?.image?.hash ? getCMSDocumentSrc(slide.value.image) : null,
        }))}
        {...blockProps}
      />
    </div>
  </section>
);

OnboardingBlock.propTypes = {
  value: PropTypes.shape({
    slides: PropTypes.array,
  }).isRequired,
  blockProps: PropTypes.object,
};

export default OnboardingBlock;
